const ButtonSend = ({ title = 'Надіслати', disabled = false, handler = null }) => {
  return (
    <button
      onClick={handler}
      disabled={disabled}
      className="btn btn_black btn_send"
      type="submit"
    >
      {title}
    </button>
  )
}

export default ButtonSend
